import React from 'react';
import styles from './BookingsTable.module.css';
import { BookingTableCellProps, BookingsTableData } from './helpers';
import { PopoverOnOverflow } from '@round/ui-kit';
import Badge from '../../../ui/Badge/Badge';
import cn from 'classnames';
import { buildInstagramUserUrl, buildTiktokUserUrl } from '../../../utils/utits';

const CreatorCell = <T extends BookingsTableData>({
    value,
    row,
    className,
}: BookingTableCellProps<T> & {
    className?: string;
}) => {
    const isCreatedByClient = row.original.is_created_by_client;
    const platform = row.original.platform;
    const influencerUserName =
        platform === 'TIKTOK' ? row.original.influencer?.tiktok_username : row.original.influencer?.instagram_username;

    const profileUrl = (() => {
        if (!influencerUserName || platform === 'YOUTUBE') {
            return null;
        }

        if (platform === 'TIKTOK') {
            return buildTiktokUserUrl(influencerUserName);
        }

        return buildInstagramUserUrl(influencerUserName);
    })();

    return (
        <PopoverOnOverflow
            popoverContent={<div className={styles.tooltip}>{value}</div>}
            popoverOptions={{ modifiers: [{ name: 'offset', options: { offset: [0, 10] } }] }}
        >
            {(setRef) => (
                <Badge
                    ref={setRef}
                    className={cn(styles.badge, styles.info, className, {
                        [styles.createdByClient]: isCreatedByClient,
                        [styles.clickable]: profileUrl,
                    })}
                    onClick={() => profileUrl && window.open(profileUrl, '_blank')}
                >
                    {value}
                </Badge>
            )}
        </PopoverOnOverflow>
    );
};

export default CreatorCell;
